
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2I7c2", function(module, exports) {

$parcel$export(module.exports, "StatusComponent", () => $cc32d587f60855db$export$fb63530bed1f6351);

var $gwFzn = parcelRequire("gwFzn");

var $iXCQx = parcelRequire("iXCQx");

var $eUDtA = parcelRequire("eUDtA");
const $cc32d587f60855db$export$fb63530bed1f6351 = ({ text: text, color: color, isBold: isBold })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        as: "span",
        testId: "status-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eUDtA.Status), {
        text: text,
        color: color,
        isBold: isBold
    }));

});


//# sourceMappingURL=StatusComponent.de7a3268.js.map
